import {SearchLgIcon} from '@components/ui/icon'
import {FC, ReactNode} from 'react'

interface EmptyStateProps {
    icon?: ReactNode
    title: string
    subtitle?: string
    customContent?: ReactNode
}
export const EmptyState: FC<EmptyStateProps> = ({title, subtitle, icon, customContent}) => {
    return (
        <div className="flex h-max w-full flex-col items-center gap-4 rounded-xl bg-neutral-50 p-10 text-center">
            {icon ?? <SearchLgIcon className="text-neutral-700" />}
            <div className="flex w-full flex-col items-center gap-1">
                <h3 className="text-md font-semibold text-neutral-900">{title}</h3>
                {!!subtitle && <h4 className="text-sm">{subtitle}</h4>}
                {customContent}
            </div>
        </div>
    )
}

EmptyState.displayName = 'EmptyState'
